export type CAMERAS_SET_CURRENT_CAMERAS_TYPE = 'CAMERAS_SET_CURRENT_CAMERAS';
export type CAMERAS_SET_CURRENT_CAMERA_TYPE = 'CAMERAS_SET_CURRENT_CAMERA';
export type CAMERAS_CLEAR_PANE_TYPE = 'CAMERAS_CLEAR_PANE';

export type CAMERAS_SET_CAMERA_LIST_SEARCH_QUERY_TYPE = 'CAMERAS_SET_CAMERA_LIST_SEARCH_QUERY';
export type CAMERAS_SET_CURRENT_STREAMS_TYPE = 'CAMERAS_SET_CURRENT_STREAMS';
export type CAMERAS_SET_INIT_ALL_STREAM_STATUS_TYPE = 'CAMERAS_SET_INIT_ALL_STREAM_STATUS';
export type CAMERAS_SET_INIT_ONE_STREAM_STATUS_TYPE = 'CAMERAS_SET_INIT_ONE_STREAM_STATUS';
export type CAMERAS_SET_CAMERAS_STREAM_FETCH_TYPE = 'CAMERAS_SET_CAMERAS_STREAM_FETCH';
export type CAMERAS_SET_CAMERAS_STREAM_SUCCESS_TYPE = 'CAMERAS_SET_CAMERAS_STREAM_SUCCESS';
export type CAMERAS_SET_CAMERAS_STREAM_ERROR_TYPE = 'CAMERAS_SET_CAMERAS_STREAM_ERROR';
export type CAMERAS_SET_CAMERAS_STREAM_STATUS_TYPE = 'CAMERAS_SET_CAMERAS_STREAM_STATUS';
export type CAMERAS_RESET_STREAMS_TYPE = 'CAMERAS_RESET_STREAMS';
export type CAMERAS_SET_PTZ_MODE_TYPE = 'CAMERAS_SET_PTZ_MODE';
export type CAMERAS_SET_CAPIBILITIES_TYPE = 'CAMERAS_SET_CAPIBILITIES';
export type CAMERAS_SET_PRESETS_TYPE = 'CAMERAS_SET_PRESETS';
export type CAMERAS_SET_DEVICE_STATUS_TYPE = 'CAMERAS_SET_DEVICE_STATUS';
export type CAMERAS_SET_CAMERA_RELOAD_TYPE = 'CAMERAS_SET_CAMERA_RELOAD';

////////////////////////////////////
export const CAMERAS_SET_CURRENT_CAMERAS : CAMERAS_SET_CURRENT_CAMERAS_TYPE = 'CAMERAS_SET_CURRENT_CAMERAS';
export const CAMERAS_SET_CURRENT_CAMERA : CAMERAS_SET_CURRENT_CAMERA_TYPE = 'CAMERAS_SET_CURRENT_CAMERA';
export const CAMERAS_CLEAR_PANE : CAMERAS_CLEAR_PANE_TYPE = 'CAMERAS_CLEAR_PANE';

export const CAMERAS_SET_CURRENT_STREAMS : CAMERAS_SET_CURRENT_STREAMS_TYPE = 'CAMERAS_SET_CURRENT_STREAMS';
export const CAMERAS_SET_CAMERA_LIST_SEARCH_QUERY : CAMERAS_SET_CAMERA_LIST_SEARCH_QUERY_TYPE = 'CAMERAS_SET_CAMERA_LIST_SEARCH_QUERY';
export const CAMERAS_SET_INIT_ALL_STREAM_STATUS : CAMERAS_SET_INIT_ALL_STREAM_STATUS_TYPE = 'CAMERAS_SET_INIT_ALL_STREAM_STATUS';
export const CAMERAS_SET_INIT_ONE_STREAM_STATUS : CAMERAS_SET_INIT_ONE_STREAM_STATUS_TYPE = 'CAMERAS_SET_INIT_ONE_STREAM_STATUS';
export const CAMERAS_SET_CAMERAS_STREAM_FETCH : CAMERAS_SET_CAMERAS_STREAM_FETCH_TYPE = 'CAMERAS_SET_CAMERAS_STREAM_FETCH';
export const CAMERAS_SET_CAMERAS_STREAM_SUCCESS : CAMERAS_SET_CAMERAS_STREAM_SUCCESS_TYPE = 'CAMERAS_SET_CAMERAS_STREAM_SUCCESS';
export const CAMERAS_SET_CAMERAS_STREAM_ERROR : CAMERAS_SET_CAMERAS_STREAM_ERROR_TYPE = 'CAMERAS_SET_CAMERAS_STREAM_ERROR';
export const CAMERAS_SET_CAMERAS_STREAM_STATUS : CAMERAS_SET_CAMERAS_STREAM_STATUS_TYPE = 'CAMERAS_SET_CAMERAS_STREAM_STATUS';
export const CAMERAS_RESET_STREAMS : CAMERAS_RESET_STREAMS_TYPE = 'CAMERAS_RESET_STREAMS';
export const CAMERAS_SET_PTZ_MODE : CAMERAS_SET_PTZ_MODE_TYPE = 'CAMERAS_SET_PTZ_MODE';
export const CAMERAS_SET_CAPIBILITIES : CAMERAS_SET_CAPIBILITIES_TYPE = 'CAMERAS_SET_CAPIBILITIES';
export const CAMERAS_SET_PRESETS : CAMERAS_SET_PRESETS_TYPE = 'CAMERAS_SET_PRESETS';
export const CAMERAS_SET_DEVICE_STATUS : CAMERAS_SET_DEVICE_STATUS_TYPE = 'CAMERAS_SET_DEVICE_STATUS';
export const CAMERAS_SET_CAMERA_RELOAD : CAMERAS_SET_CAMERA_RELOAD_TYPE = 'CAMERAS_SET_CAMERA_RELOAD';


